import { apiFetch, parseApiResponse } from '../../utils/apiClient';

/**
 * Fetch all projects from the backend API
 * @returns {Promise<Array>} Array of project objects
 */
export const getAllProjects = async () => {
  try {
    const response = await apiFetch('/api/projects/GetAllProjects');
    return await parseApiResponse(response);
  } catch (error) {
    console.error('Error fetching projects:', error);
    throw error;
  }
};

/**
 * Fetch one project from the backend API
 * @param {string|number} projectId Project identifier
 * @returns {Promise<Object>} Project object
 */
export const getOneProject = async (projectId) => {
  try {
    const response = await apiFetch(`/api/projects/project/${projectId}`);
    return await parseApiResponse(response);
  } catch (error) {
    console.error('Error fetching project:', error);
    throw error;
  }
};

/**
 * Update one project
 * @param {string|number} projectId Project identifier
 * @param {Object} payload Project data
 * @returns {Promise<Object>} Updated project
 */
export const updateProject = async (projectId, payload) => {
  try {
    const response = await apiFetch(`/api/projects/project/${projectId}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });

    return await parseApiResponse(response);
  } catch (error) {
    console.error('Error updating project:', error);
    throw error;
  }
};

export const getProjectNodes = async (projectId) => parseApiResponse(await apiFetch(`/api/projects/${projectId}/nodes`));
export const getResolvedProjectNodes = async (projectId) => parseApiResponse(await apiFetch(`/api/projects/${projectId}/nodes/resolved`));

export const createProjectNode = async (projectId, payload) => parseApiResponse(await apiFetch(`/api/projects/${projectId}/nodes`, {
  method: 'POST', body: JSON.stringify(payload),
}));

export const getProjectPlanningTraceability = async (projectId) => {
  const response = await apiFetch(`/api/projects/project/${projectId}/planning-traceability`);
  return parseApiResponse(response);
};
